import React from "react";
import styles from "./Payouts.module.sass";
import PayoutHistory from "./PayoutHistory";
import StatFacturation from "./StatFacturation";

const InvoiceDetails = () => {
    return (
        <>
            <div className={styles.section}>
                <StatFacturation className={styles.card} />
                {/* <PayoutHistory /> */}
            </div>
        </>
    );
};

export default InvoiceDetails;
